import { Container, SxProps } from '@mui/material'
import { Stack } from '@mui/material'
import { ArbipayProject } from './arbipay'
import { ArbipointProject } from './arbipoint'
import { PlanetExpansion } from './components'
import { StartapPlatformProject } from './startap-platform'

interface IProps {
  sx?: SxProps
}

export function BothProjects({ sx }: IProps) {
  return (
    <Container maxWidth={'lg'} component="section" sx={sx} id="projects">
      <Stack gap={{ xs: '64px', md: '150px' }}>
        <Stack>
          <ArbipointProject />

          <PlanetExpansion
            project="arbipoint"
            sx={{
              mt: {
                xs: '32px',
                md: '100px',
              },
            }}
          />
        </Stack>

        <Stack>
          <ArbipayProject />

          <PlanetExpansion
            project="arbipay"
            sx={{
              mt: {
                xs: '32px',
                md: '100px',
              },
            }}
          />
        </Stack>

        <StartapPlatformProject />
      </Stack>
    </Container>
  )
}
